import { render, staticRenderFns } from "./TablaBeneficiosConCodigo.vue?vue&type=template&id=834e0022&scoped=true&"
import script from "./TablaBeneficiosConCodigo.vue?vue&type=script&lang=js&"
export * from "./TablaBeneficiosConCodigo.vue?vue&type=script&lang=js&"
import style0 from "./TablaBeneficiosConCodigo.vue?vue&type=style&index=0&id=834e0022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834e0022",
  null
  
)

export default component.exports